import React from 'react';
import { Link } from 'react-router-dom';
import AsamaImg from '../../assets/asama-bir.png';
import AsamaIkiImg from '../../assets/asama-iki.png';
import SurdurulebilirlikImg from '../../assets/surdurulebilirlik.png';
import Footer from "../../components/footer/Footer";
import Header from '../../components/header/Header';
import HeaderToggle from '../../components/headerToggle/HeaderToggle';
import useWindowSize from '../../hooks/useWindowSize';
import './SustainabilityScreen.css';

const SustainabilityScreen = () => {
  const { width: screenWidth } = useWindowSize();

  return (
    <div>
      {/* Header */}
      {screenWidth < 910 ? (
        <HeaderToggle />
      ) : (
        <Header />
      )}

      {/* Header Spacer */}
      <div className="header-spacer" />
      
      <main className="sustainability-container">
        {/* Hero Section */}
        <section className="sustainability-hero">
          <div className="hero-icon">🌿</div>
          <h1>Sürdürülebilirlik</h1>
          <p className="hero-subtitle">
            Timya Otel olarak geleceğe daha yeşil bir dünya bırakmak için çalışıyoruz
          </p>
        </section>

        {/* Giriş Bölümü */}
        <section className="sustainability-intro">
          <p>
            Timya Otel'de çevresel sorumluluğumuzu ciddiye alıyoruz. 2011 yılından bu yana 
            misafirlerimize sunduğumuz kaliteli hizmeti, doğaya ve çevreye olan saygımızla 
            birleştiriyoruz. Sürdürülebilir turizm anlayışımızla, hem misafirlerimize 
            unutulmaz deneyimler sunuyor hem de gezegenimizi korumak için aktif adımlar atıyoruz.
          </p>
        </section>

        {/* Yerel ve Sosyal Sorumluluk */}
        <section className="sustainability-section">
          <h2>Yerel Toplum ve Sosyal Sorumluluk</h2>
          <div className="social-grid">
            <article className="social-item">
              <div className="social-icon">🤝</div>
              <h3>Yerel Tedarikçiler</h3>
              <p>
                Kahvaltı malzemelerimizden temizlik ürünlerimize kadar, 
                mümkün olduğunca yerel ve bölgesel tedarikçilerle çalışıyoruz. 
                Bu sayede karbon ayak izimizi azaltıyor ve yerel ekonomiyi destekliyoruz.
              </p>
            </article>

            <article className="social-item">
              <div className="social-icon">👥</div>
              <h3>Toplum Katkısı</h3>
              <p>
                Kadıköy'deki çevre temizlik kampanyalarına katılıyor, 
                yerel okullara çevre bilinci eğitimleri veriyor ve 
                sosyal sorumluluk projelerine destek oluyoruz.
              </p>
            </article>

            <article className="social-item">
              <div className="social-icon">📚</div>
              <h3>Personel Eğitimi</h3>
              <p>
                Tüm ekip üyelerimiz düzenli olarak çevre bilinci ve 
                sürdürülebilirlik eğitimleri almaktadır. Her çalışanımız 
                bu misyonun bir parçasıdır.
              </p>
            </article>
          </div>
        </section>

        {/* Sertifikalar */}
        <section className="sustainability-section certificates-section">
          <h2>Sertifikalarımız</h2>
          <p className="certificates-intro">
            Timya Otel, T.C. Kültür ve Turizm Bakanlığı ve Türkiye Turizm Tanıtım ve 
            Geliştirme Ajansı (TGA) tarafından "Sürdürülebilir Turizm" sertifikasına 
            layık görülmüştür.
          </p>
          <div className="certificates-list">
            <img 
              src={SurdurulebilirlikImg} 
              alt="Sürdürülebilir Turizm Sertifikası"
              className="certificate-full-image"
            />
            <img 
              src={AsamaImg} 
              alt="Sürdürülebilir Turizm 1. Aşama Belgesi"
              className="certificate-full-image"
            />
            <img 
              src={AsamaIkiImg} 
              alt="Sürdürülebilir Turizm 2. Aşama Belgesi"
              className="certificate-full-image"
            />
          </div>
        </section>

        {/* İşbirlikleri */}
        <section className="sustainability-section certifications-section">
          <h2>İşbirliklerimiz</h2>
          <p>
            Sürdürülebilirlik hedeflerimize ulaşmak için çeşitli kurum ve kuruluşlarla 
            işbirliği içinde çalışıyoruz. Çevre ve Şehircilik Bakanlığı'nın önerdiği 
            uygulamaları takip ediyor, TUROB (Turistik Otelciler ve İşletmeciler Birliği) 
            ile sürdürülebilir turizm standartlarını benimsiyoruz.
          </p>
        </section>

        {/* İletişim */}
        <section className="sustainability-contact">
          <h3>Sorularınız mı var?</h3>
          <p>
            Sürdürülebilirlik uygulamalarımız hakkında daha fazla bilgi almak veya 
            önerilerinizi paylaşmak için bizimle iletişime geçebilirsiniz.
          </p>
          <Link to="/iletisim" className="contact-btn">İletişime Geçin</Link>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default SustainabilityScreen;
